<script lang="ts">
	import type { ClassValue } from "svelte/elements";
	import star from "@core/assets/icons/star.svg?raw";
	import Icon from "./common/Icon.svelte";
	import Media from "./common/Media.svelte";
	import type { MediaSrc } from "./common/MediaSrc.js";

	const {
		description,
		profile,
		name,
		image,
		stars,
		class: customClass,
	}: {
		description: string;
		profile: MediaSrc;
		image: MediaSrc;
		stars: number;
		name: string;
		class?: ClassValue;
	} = $props();

	const starsFilled = Array.from({ length: 5 }, (_, i) => i < stars);
</script>

<div
	class={[
		"bg-nov-light-100 max-w-[26rem] border border-nov-light-200 p-4 lg:p-6 gap-3 lg:gap-6 flex-col justify-between flex rounded-2xl lg:rounded-3xl",
		customClass,
	]}
>
	<div class="flex flex-col gap-[inherit]">
		<div class="flex flex-col xs:flex-row gap-4 mx-auto items-center">
			<Media source={profile} alt="" width={96} height={96} eager class="size-18 rounded-full" />
			<div class="flex flex-col">
				<p class="text-title3 font-bold">{name}</p>
				<div class="flex gap-0.5 items-center p-px">
					<div class="mr-1.5 flex items-center font-semibold">
						<span class="text-[.9375rem]/5.5">{stars} z 5</span>
					</div>
					{#each starsFilled as isFilled, i (i)}
						<Icon icon={star} class={[isFilled ? "text-[#FFB238]" : "text-[#C6C6C6]", "size-5"]} />
					{/each}
				</div>
			</div>
		</div>
		<p class="text-[.9375rem]/5.5 text-center text-nov-dark-800 px-2">
			{description}
		</p>
	</div>
	<Media
		source={image}
		alt="Recenze produktu"
		width={400}
		height={0}
		eager
		class="rounded-lg object-cover aspect-[176/132] w-full"
	/>
</div>
